export default {"src":"/_next/static/media/4technical.bed4b994.svg","height":40,"width":25,"blurWidth":0,"blurHeight":0};